import { setCreateApp } from '../utility'
import { createBaseApp } from 'app/common/createApp'

setCreateApp(createBaseApp)